import { useNavigate } from "react-router-dom";
import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListIcon from "@mui/icons-material/List";
import GroupIcon from "@mui/icons-material/Group";
import { useAuth } from "../auth/AuthContext";

// Physician home (English production UI): только навигация — счётчики и
// история видны в списке пациентов, дублировать их здесь не нужно.
export default function PhysicianHomePage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const isNurse = user?.role === "test_administrator";
  const allNavItems = [
    {
      icon: <ListIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "My Patients",
      subtitle: isNurse ? "Patient list and tests" : "Patient list and test results",
      path: "/physician/patients",
    },
    {
      icon: <PersonAddIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "New Patient",
      subtitle: "Register a patient",
      path: "/physician/create-patient",
    },
    {
      icon: <GroupIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      title: "My Team",
      subtitle: "Nurse accounts",
      path: "/physician/team",
    },
  ];
  // медсестре — только пациенты и регистрация (без команды)
  const navItems = isNurse ? allNavItems.filter((i) => i.path !== "/physician/team") : allNavItems;

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <Typography variant="h5" sx={{ textAlign: "center" }}>
        {user?.name ? `Welcome, ${user.name}` : isNurse ? "Nurse Dashboard" : "Physician Dashboard"}
      </Typography>

      {navItems.map((item) => (
        <Card key={item.path}>
          <CardActionArea onClick={() => navigate(item.path)}>
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, py: 2 }}>
              {item.icon}
              <div>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {item.subtitle}
                </Typography>
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  );
}
